module.exports = __webpack_public_path__ + "static/media/laptop.e4288054.png";